function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f7c9d6;}.cls-12,.cls-13,.cls-2,.cls-3,.cls-7,.cls-9{fill:none;}.cls-2{stroke:#ae9fd3;}.cls-12,.cls-13,.cls-2,.cls-3,.cls-9{stroke-miterlimit:10;}.cls-13,.cls-2,.cls-9{stroke-width:3px;}.cls-13,.cls-3,.cls-7{stroke:#fff;}.cls-12,.cls-3,.cls-7{stroke-width:2px;}.cls-4{fill:#fff;}.cls-5{fill:#fcce44;}.cls-6{fill:#170c2c;}.cls-7{stroke-linejoin:round;}.cls-8{fill:#c64f4b;}.cls-9{stroke:#170c2c;}.cls-10{fill:#dd6464;}.cls-11{fill:#0083c8;}.cls-12{stroke:#dd6464;}"));

var _ref3 = /*#__PURE__*/React.createElement("title", null, "6");

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  className: "cls-1",
  cx: 816.74,
  cy: 53.19,
  r: 27.17
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  className: "cls-1",
  cx: 82.42,
  cy: 345.01,
  r: 27.17
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M873.49,393.84c40.6-97.56,73.67-186,100-188.07,22.59-1.76,12.15,66.51,32.92,69.36s103.35-107.59,134.72-102.85,62.64,266.3,78.33,268.11,18.79-130.19,38.72-129.19S1284,440.64,1284,440.64",
  transform: "translate(-263.91 -170.63)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M306.81,589s54-121.25,153.66-107.93,114.16,201.33,241.18,168C748.32,636.8,789.73,574.33,826.27,500",
  transform: "translate(-263.91 -170.63)"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M903.19,749.94C879.06,827.44,759.13,880.75,680.4,853.6a100.15,100.15,0,0,1-37.19-22.32,94.77,94.77,0,0,1-15-18.64c-17.5-28.36,7.5-63.1,21.84-114.49C665.67,642,636.6,595.44,676.85,569a106.78,106.78,0,0,1,24.51-12c25.25-8.58,52.29-7.06,78.2,1.59C858,584.69,926.18,676.09,903.19,749.94Z",
  transform: "translate(-263.91 -170.63)"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M626.43,766.43s71.68-49.92,83.89-45-21.83,119.79-21.83,119.79",
  transform: "translate(-263.91 -170.63)"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M706.64,555.3S669,651.59,694.44,676.46s110.36-69.9,110.36-69.9-25.44,38.57-22.16,58.26,97.69-27.11,97.69-27.11",
  transform: "translate(-263.91 -170.63)"
});

var _ref11 = /*#__PURE__*/React.createElement("ellipse", {
  className: "cls-4",
  cx: 501.04,
  cy: 553.39,
  rx: 18.11,
  ry: 24.75
});

var _ref12 = /*#__PURE__*/React.createElement("circle", {
  className: "cls-5",
  cx: 54.35,
  cy: 572.3,
  r: 54.35
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1672.22,718.17a43.75,43.75,0,0,1,.17-87.5h.17a43.75,43.75,0,0,1-.17,87.49Z",
  transform: "translate(-263.91 -170.63)"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  className: "cls-6",
  d: "M1672.39,632.17h.17a42.25,42.25,0,0,1-.17,84.5h-.17a42.25,42.25,0,0,1,.17-84.5m0-3a45.25,45.25,0,0,0-.18,90.5h.18a45.25,45.25,0,0,0,.18-90.5Z",
  transform: "translate(-263.91 -170.63)"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M1564.69,601.35a143,143,0,0,1-36.92,95.53,144.72,144.72,0,0,1-24.24,21.45,143.53,143.53,0,0,1-225.8-112.88c-.06-1.74-.09-3.48-.08-5.24a143.52,143.52,0,0,1,287,1.14Z",
  transform: "translate(-263.91 -170.63)"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1277.73,605.45c-.06-1.74-.09-3.48-.08-5.24a143.5,143.5,0,0,1,3.85-32.6c8.91-4.66,16-6,18.94-2.82C1305.69,570.44,1295.57,588.4,1277.73,605.45Z",
  transform: "translate(-263.91 -170.63)"
});

var _ref17 = /*#__PURE__*/React.createElement("ellipse", {
  className: "cls-4",
  cx: 1388.1,
  cy: 600.65,
  rx: 24.09,
  ry: 35.17,
  transform: "translate(51.18 1495.99) rotate(-68.21)"
});

var _ref18 = /*#__PURE__*/React.createElement("ellipse", {
  className: "cls-4",
  cx: 1486.82,
  cy: 511.01,
  rx: 14.02,
  ry: 16.11,
  transform: "translate(-225.05 952.9) rotate(-41.9)"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M1558.19,643.59c-24.65-37.72-64.69-91.11-89-82.32-36.83,13.34-22,147.41-33.45,148.82s-28.18-31.11-39.6-27.7c-12.71,3.8-23.81,33.43-29.43,51.24",
  transform: "translate(-263.91 -170.63)"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  className: "cls-7",
  d: "M1309.78,510.28c19.85,20.05,40.74,37.86,48.59,33.32,11.62-6.72,5.49-48.59,5.49-48.59s34.46,62.55,57.11,55.61c15.3-4.69-1.73-67-9.58-93",
  transform: "translate(-263.91 -170.63)"
});

var _ref21 = /*#__PURE__*/React.createElement("polygon", {
  className: "cls-5",
  points: "417.57 286.01 289.8 238.39 249.63 223.43 152.31 187.16 354.58 33.72 382.74 12.35 386.53 42.09 417.57 286.01"
});

var _ref22 = /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "1105.04 657.46 1402.88 658.64 1275.04 888.01 1105.04 657.46"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M1603.46,829s-52.32,26.31-53.69,46.67,41.41,29.85,41.41,29.85-39.84,4.9-45.61,41.84c-5.18,33.24,16.76,69.32,16.76,69.32",
  transform: "translate(-263.91 -170.63)"
});

var _ref24 = /*#__PURE__*/React.createElement("polygon", {
  className: "cls-5",
  points: "249.43 740.14 196.81 967.27 434.82 911.73 249.43 740.14"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M589.27,1057.18s119.55,147.59,171.43,145.6c21.85-.83-11.48-55.43.23-58.15s44.72,50.95,85.41,30.8c63.14-31.26-7-224.34,126.45-287.5s191.11,49.68,267.71,54.59S1483,770.87,1545.76,780.34s-135.24,274.24-96.37,325.47c22.21,29.27,73.92-18.17,94.2-10.7s-11.24,41.49,6.28,47.1,143.34-66.82,143.34-66.82",
  transform: "translate(-263.91 -170.63)"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M1001.49,353.93s-40.7,17.32-50,46.34,21.31,60.33,21.31,60.33l97.38-20.37Z",
  transform: "translate(-263.91 -170.63)"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  className: "cls-8",
  d: "M1095.18,621.4A118,118,0,1,0,896.75,493.64Z",
  transform: "translate(-263.91 -170.63)"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M1046,473.79l20-74s26.59-6.79,26.17-24.85-19.59-14.4-19.59-14.4-3-25.32-27.85-32.87-45.26,18.36-48,38.88c-4,30.3,5.39,47.5,36.6,47.54l-13,40.24",
  transform: "translate(-263.91 -170.63)"
});

var _ref29 = /*#__PURE__*/React.createElement("line", {
  className: "cls-9",
  x1: 750.08,
  y1: 199.33,
  x2: 742.12,
  y2: 211.57
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M1051.51,453.41c-25.27-14.32,10.35-99.31,10.35-99.31-30.69,9.59-59.39-4.42-59.39-4.42s17.4-40.6,62.17-24.91,48.11,47.37,48.11,47.37,46.35,23.13,37.93,63-56.93,56.32-56.93,56.32S1071.6,464.79,1051.51,453.41Z",
  transform: "translate(-263.91 -170.63)"
});

var _ref31 = /*#__PURE__*/React.createElement("ellipse", {
  className: "cls-10",
  cx: 615.9,
  cy: 290.8,
  rx: 20.18,
  ry: 15.03,
  transform: "translate(-158.78 570.74) rotate(-66.69)"
});

var _ref32 = /*#__PURE__*/React.createElement("polygon", {
  className: "cls-11",
  points: "1068.15 865.36 1071.59 942.67 1030.45 1045.85 1027.01 968.54 1068.15 865.36"
});

var _ref33 = /*#__PURE__*/React.createElement("polygon", {
  className: "cls-5",
  points: "994.37 1050.21 709.7 936.74 706.26 859.43 990.93 972.9 994.37 1050.21"
});

var _ref34 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-4",
  x: 1079.08,
  y: 883.55,
  width: 107.93,
  height: 303.44,
  transform: "translate(-512.08 1533.83) rotate(-68.27)"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  className: "cls-6",
  d: "M1012.93,930.91,1292,1042.15l-38.85,97.48-279.1-111.25,38.86-97.47m-1.68-3.9-41.07,103,284.66,113.47,41.08-103L1011.25,927Z",
  transform: "translate(-263.91 -170.63)"
});

var _ref36 = /*#__PURE__*/React.createElement("polygon", {
  className: "cls-5",
  points: "1074.28 101.98 1094.7 65.35 1214.62 35.02 1194.19 71.65 1074.28 101.98"
});

var _ref37 = /*#__PURE__*/React.createElement("polygon", {
  className: "cls-11",
  points: "1260.47 205.72 1280.89 169.08 1250.56 49.17 1230.14 85.8 1260.47 205.72"
});

var _ref38 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-4",
  x: 1388.91,
  y: 271.21,
  width: 120.69,
  height: 120.69,
  transform: "translate(-300.97 194.86) rotate(-14.19)"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  className: "cls-6",
  d: "M1491.88,260.08l28.85,114.09L1406.64,403l-28.86-114.1,114.1-28.85m2.17-3.65-119.92,30.33,30.33,119.92,119.92-30.33-30.33-119.92Z",
  transform: "translate(-263.91 -170.63)"
});

var _ref40 = /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "1105.04 657.46 1207.98 657.87 1177.36 755.54 1105.04 657.46"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1527.77,696.88a144.72,144.72,0,0,1-24.24,21.45c-1.83-4.62-3.55-9.6-5.09-14.84-8-27.44-8.14-51.58-.19-53.91s20.93,18,29,45.46C1527.42,695.66,1527.6,696.27,1527.77,696.88Z",
  transform: "translate(-263.91 -170.63)"
});

var _ref42 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-4",
  x: 250.66,
  y: 743.62,
  width: 269.12,
  height: 114.15,
  transform: "translate(-766.22 672.39) rotate(-67.04)"
});

var _ref43 = /*#__PURE__*/React.createElement("path", {
  className: "cls-6",
  d: "M386,656.49,488.3,699.85l-103.82,245L282.14,901.53,386,656.49m-1.59-3.93L278.21,903.12l107.86,45.7L492.23,698.26l-107.86-45.7Z",
  transform: "translate(-263.91 -170.63)"
});

var _ref44 = /*#__PURE__*/React.createElement("ellipse", {
  className: "cls-11",
  cx: 438.3,
  cy: 675.41,
  rx: 21.29,
  ry: 58.57,
  transform: "translate(-618.5 644.86) rotate(-67.04)"
});

var _ref45 = /*#__PURE__*/React.createElement("ellipse", {
  className: "cls-1",
  cx: 332.14,
  cy: 925.97,
  rx: 21.29,
  ry: 58.57,
  transform: "translate(-913.95 699.92) rotate(-67.04)"
});

var _ref46 = /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1116.74,491.51s14.77,1.35,22.08,18.61,10.13,84.48,38.33,111.6,93.41,32.8,113.17,17c20.68-16.54,23.21-34.37,42.91-35.52s26.41,11.18,24.55,14.25-20.93,2.68-22.79,7",
  transform: "translate(-263.91 -170.63)"
});

var _ref47 = /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1085.65,650.57s80.55,173,282,27.38",
  transform: "translate(-263.91 -170.63)"
});

var _ref48 = /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M686.55,342.18s32.81,107.79,58,119.66,140.57,33.53,140.57,33.53",
  transform: "translate(-263.91 -170.63)"
});

var _ref49 = /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M736.69,309.14s43.59,85.35,73.09,93.52,78.4,3.22,123.38,21.72",
  transform: "translate(-263.91 -170.63)"
});

var _ref50 = /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M666.56,302.1s-50.24-3.69-51.65-9.64S683.26,281,683.26,281",
  transform: "translate(-263.91 -170.63)"
});

var _ref51 = /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M695.71,296.88s-15.22,10-16,5.27,6-25,20.41-25.15,41.39,12.06,33.75,23.93-24.62.31-24.62.31",
  transform: "translate(-263.91 -170.63)"
});

var _ref52 = /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M649,300.44s-.15,14.92,12.36,17,30.75,4.43,32-1.31-16.39-5-18.21-12",
  transform: "translate(-263.91 -170.63)"
});

var _ref53 = /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M683.11,319.75s13.16,6.9,9.19,11.17c-2.48,2.65-30.92-13.46-30.92-13.46",
  transform: "translate(-263.91 -170.63)"
});

var _ref54 = /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1351.41,595.57s37.81-6.13,43.36,5.1c2.14,4.32-36.88,14.19-36.88,14.19",
  transform: "translate(-263.91 -170.63)"
});

var _ref55 = /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1375.92,622.51s3.58,35.16-18,34.24c-5.83-.25,8.7-24.81.11-27",
  transform: "translate(-263.91 -170.63)"
});

var _ref56 = /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1376.07,645.21s8.54,23.95-3.23,28c-2.66.91-2.27-14.3-6.58-16.4",
  transform: "translate(-263.91 -170.63)"
});

var _ref57 = /*#__PURE__*/React.createElement("ellipse", {
  className: "cls-6",
  cx: 1006.58,
  cy: 363.83,
  rx: 5.31,
  ry: 3.48,
  transform: "matrix(0, -1, 1, 0, 374.86, 1198.33)"
});

var _ref58 = /*#__PURE__*/React.createElement("ellipse", {
  className: "cls-6",
  cx: 1023.49,
  cy: 366.71,
  rx: 5.31,
  ry: 3.48,
  transform: "translate(388.82 1218.11) rotate(-89.77)"
});

var _ref59 = /*#__PURE__*/React.createElement("path", {
  className: "cls-12",
  d: "M664.07,319.81s-73.5,6.39-75.32,22.5,44.93,23.86,45.31,27.11-52.2,12.74-50.58,26.59,94.24,40.17,94.24,40.17",
  transform: "translate(-263.91 -170.63)"
});

var _ref60 = /*#__PURE__*/React.createElement("path", {
  className: "cls-12",
  d: "M576.6,236.13s61-18.1,62.14-8.11c1.53,13.12-126.17,63.54-126,72.19s45,3,46.09,9.06-108.91,61.09-108.91,61.09",
  transform: "translate(-263.91 -170.63)"
});

var _ref61 = /*#__PURE__*/React.createElement("path", {
  className: "cls-10",
  d: "M553.71,409l-40.17-15c7.59-23.52,19.5-39.44,29.25-37.38C553.37,358.9,557.78,381.49,553.71,409Z",
  transform: "translate(-263.91 -170.63)"
});

var _ref62 = /*#__PURE__*/React.createElement("path", {
  d: "M909.06,653.86c-102.52,15.29-246.7,127.61-239.59,196.87S843.2,1037.26,843.2,1037.26s-28.15,38.35-21.19,67.92L948.4,987,834.07,875.38l119.46-77.22,105.54,37.49-34.69,239.87,147.95,65.2s-10-44.35-38.53-61.08c0,0,107.26-278.65,67.83-344.66S1009.49,638.89,909.06,653.86Z",
  transform: "translate(-263.91 -170.63)"
});

var _ref63 = /*#__PURE__*/React.createElement("line", {
  className: "cls-13",
  x1: 535.1,
  y1: 668.02,
  x2: 638.73,
  y2: 769.56
});

var _ref64 = /*#__PURE__*/React.createElement("line", {
  className: "cls-13",
  x1: 796.82,
  y1: 640.52,
  x2: 791.16,
  y2: 678.85
});

var _ref65 = /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M1402.38,873.43s45.17-24.51,65.2-4.34C1489.29,891,1454,943.37,1454,943.37",
  transform: "translate(-263.91 -170.63)"
});

var SvgHero = function SvgHero(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer",
    viewBox: "0 0 1453.73 1050.21",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, _ref65);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHero, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/hero.37139262.svg";
export { ForwardRef as ReactComponent };